import { FC } from "react"

export interface CardCollapseButtonProps {
  onClick: () => void
  collapsed: boolean
  title: string
}

const CardCollapseButton: FC<CardCollapseButtonProps> = ({
  onClick,
  title,
  collapsed
}) => {
  return (
    <header
      onClick={onClick}
      role="button"
      tabIndex={0}
      className="ocs-fields-card-header ocs-mb-4"
    >
      <h3 className="ocs-fields-card-title">{title}</h3>
      <button type="button" className="ocs-card-collapse-btn ">
        <span
          className={
            "ocs-card-collapse-btn-triangle" +
            (collapsed ? " triangle-down" : " triangle-up")
          }
        />
      </button>
    </header>
  )
}

export default CardCollapseButton
